/**
 * mulberry32 — mały, szybki PRNG o dobrym rozkładzie.
 * Używany zamiast `Math.random()`, żeby losowanie floty i wygląd kreski
 * dało się odtworzyć w testach i po stronie serwera z zapisanego ziarna.
 */
export function mulberry32(seed) {
    let a = seed >>> 0;
    return () => {
        a = (a + 0x6d2b79f5) >>> 0;
        let t = Math.imul(a ^ (a >>> 15), 1 | a);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}
/** Losowa liczba całkowita z przedziału `[0, maxExclusive)`. */
export function randomInt(rng, maxExclusive) {
    return Math.floor(rng() * maxExclusive);
}
/** Losowy element tablicy. Zwraca `undefined` dla pustej tablicy. */
export function pick(rng, items) {
    if (items.length === 0)
        return undefined;
    return items[randomInt(rng, items.length)];
}
//# sourceMappingURL=rng.js.map